/* ++++++++++ --------------- EXPORT : DATA CPM : STYLES --------------- ++++++++++ */
export default theme => ({
    cpm:{

    }
});
